/**
 * Lage des Hover-Fensters von ClampedText im Viewport — eigene Datei, weil
 * eine Komponentendatei fuer Fast Refresh nur Komponenten exportieren darf.
 */

const GAP = 6;
const EDGE = 8;
const MAX_WIDTH = 448;
const MAX_HEIGHT = 320;

export interface Placement {
  left: number;
  width: number;
  top?: number;
  bottom?: number;
  maxHeight: number;
}

export const placeHoverWindow = (
  anchor: Pick<DOMRect, 'left' | 'top' | 'bottom'>,
  vw: number,
  vh: number,
): Placement => {
  const width = Math.min(MAX_WIDTH, vw - 2 * EDGE);
  const left = Math.max(EDGE, Math.min(anchor.left, vw - width - EDGE));
  const below = vh - anchor.bottom - GAP - EDGE;
  const above = anchor.top - GAP - EDGE;
  // Unten, solange dort Platz ist; sonst dorthin, wo mehr Platz ist.
  if (below >= 160 || below >= above) {
    return { left, width, top: anchor.bottom + GAP, maxHeight: Math.min(MAX_HEIGHT, below) };
  }
  return { left, width, bottom: vh - anchor.top + GAP, maxHeight: Math.min(MAX_HEIGHT, above) };
};
